<template>
  <div class="floating-container">
    <div class="floating-header">
      <h1>Site Strategies</h1>
      <button class="small" @click="addStrategy">+ Add Strategy</button>
      <router-link to="../"><button class="small">← Go Back</button></router-link>
    </div>
    <div id="strategy_list">
      <Table v-bind:head="head" v-bind:body="body" name="strategies" />
    </div>
  </div>
</template>

<script>
import Table from "../generics/Table";
import utils from "@/js/utils";
import request from "@/js/request";

import EventBus from "@/js/event-bus.js";

const { api_path } = utils;

const methods = {
  process: {
    strategies (strategies) {
      return strategies.map(strategy => {
        return {
          key: strategy.public_key,
          data: [
            { link: `${strategy.public_key}/`, html: strategy.name },
            { html: `<code>${strategy.public_key}</code>` },
            { html: strategy.description },
            { html: utils.formatTime(new Date(strategy.createdAt)) },
            { html: utils.formatLengthOfTime(strategy.duration * 1000 * 60) },
          ]
        }
      });
    },
  },
};

export default {
  name: 'SiteStrategies',
  props: ["strategies"],
  data () {
    const data = {
      head: [
        { name: "name", placeholder: "Strategy Name", html: "Name", width: 250 },
        { html: "Public Key", width: 150 },
        { name: "description", placeholder: "A small description here.", html: "Description", width: 500 },
        { html: "Created On", width: 100, align: "right" },
        { name: "duration", placeholder: "10 days", html: "Duration", width: 100, align: "right" },
      ],
      body: [],
    };

    (async () => {
      data.organization = (await utils.generalInformation()).organization;
    })();

    return data;
  },

  beforeUpdate () {
    console.log("updated");
  },

  methods: {
    addStrategy: (() => {
      let editing = false;
      return async function (e) {
        if (editing === false) {
          e.target.innerText = "Save Strategy";
          editing = true;
          this.$data.body.unshift({ empty: true });
        } else {
          let table = e.target.parentNode.nextElementSibling;
          let data = utils.getFormInput(table);

          // we want time in minutes becuase I suck.
          data.duration = utils.lengthOfTimeToMilliseconds(data.duration) / (1000 * 60);

          if (data.name && data.description && data.duration) {
            let response = await request(`${api_path.test}/organizations/me/strategies/`, {
              headers: { Authorization: `Basic ${this.$data.organization.testing_organization_auth_token}` }
            }).post(data);

            this.$emit("updateStrategies");

            editing = false;
            e.target.innerText = "+ Add Strategy";
          }
        }
      }
    })(),

    updateStrategy: (data) => {
      console.log(data)
    },
  },

  mounted () {
    this.$on("edit", payload => {
      let { idx, name } = payload;

      this.$data.body[idx].data = this.$data.body[idx].data.map((o, col_idx) => {
        return Object.assign(o, { edit: !!this.$data.head[col_idx].name });
      });

      this.$data.body = this.$data.body.map(o => o);
      console.log("edit")
    });

    this.$on("save", async payload => {
      let { data, key } = payload;
      // we want time in minutes becuase I suck.
      data.duration = utils.lengthOfTimeToMilliseconds(data.duration) / (1000 * 60);

      let response = await request(`${api_path.test}/organizations/me/strategies/${key}`, {
        headers: { Authorization: `Basic ${this.$data.organization.testing_organization_auth_token}` }
      }).put(data);

      this.$emit("updateStrategies");
    });
  },

  watch: {
    strategies () {
      this.$data.body = methods.process.strategies(this.strategies);
    },
  },

  components: {
    Table,
  },
};
</script>

<style scoped>
#strategy_list {
  width: 1252px;
}
</style>



// WEBPACK FOOTER //
// src/components/special/SiteStrategies.vue